module.exports = __webpack_public_path__ + "img/cu04.ed7869c2.jpg";